module.exports = __webpack_public_path__ + "assets/img/kv-ab3e2b0b.jpg";